import React from 'react'
import AdminHeader from "./AdminHeader"
import AdminAllProjectsTable from "./AdminAllProjectsTable"
import {useBreadcrumbs} from "../layouts/Nav/BreadcrumbsProvider"
import {NAV_LABELS} from "../../library/NavLabels"

function AdminProjectsPage() {
    useBreadcrumbs([{label: NAV_LABELS.PROJECTS}])

    return (
        <>
            <AdminHeader/>
            <AdminAllProjectsTable/>
        </>
    );
}

export default AdminProjectsPage;